import { useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
export const personHeaderKeys = {
  all: ['personHeader'] as const,
  detail: (personId: string) => [...personHeaderKeys.all, personId] as const
} as const;
export const usePersonHeader = (personId: string) => useSuspenseQuery({
  queryKey: personHeaderKeys.detail(personId),
  queryFn: async () => {
    const res = await apiClient.GET('/v2/people/{personId}/header', {
      params: {
        path: {
          personId
        }
      }
    });
    return getDataOrThrowApiError(res);
  }
});